import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { withTranslation } from 'react-i18next';
import { setPaqueteFiltrados } from '../../redux/actions/packages-actions';
import CategoriaEstrella from './categoriaEstrella';
import Commons from '../../commons/commons';
import './filtros.css';
/* eslint-disable */
const Range = Slider.Range;

class Filtros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cantNoches: [],
      paquetes: [],
      hoteles: [],
      categoriaHotel: [],
      proveedores: [],
      precioMinimo: 0,
      precioMaximo: null,
      precio: [0, 1],
      fechaMinima: null,
      fechaMaxima: null,
      fechas: [0, 1],
      invertirPrecio: false,
      disponible: true,
      filtroCupos: false,
      aplicando: false,
    };
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleCheckboxHoteles = this.handleCheckboxHoteles.bind(this);
    this.aplicarFiltroCupos = this.aplicarFiltroCupos.bind(this);
    this.prepararFiltros = this.prepararFiltros.bind(this);
    this.aplicarFiltros = this.aplicarFiltros.bind(this);
    this.contadorChecks = this.contadorChecks.bind(this);
    this.aplicarFiltroCantNoches = this.aplicarFiltroCantNoches.bind(this);
    this.aplicarFiltroFechas = this.aplicarFiltroFechas.bind(this);
    this.aplicarFiltroPrecios = this.aplicarFiltroPrecios.bind(this);
    this.aplicarFiltroInvertir = this.aplicarFiltroInvertir.bind(this);
    this.aplicarFiltroProveedor = this.aplicarFiltroProveedor.bind(this);
    this.aplicarFiltroCategoriaHotel = this.aplicarFiltroCategoriaHotel.bind(this);
    this.aplicarFiltroHoteles = this.aplicarFiltroHoteles.bind(this);
    this.armarCantNoches = this.armarCantNoches.bind(this);
    this.armarOperadores = this.armarOperadores.bind(this);
    this.armarCategoriaHotel = this.armarCategoriaHotel.bind(this);
    this.armarHoteles = this.armarHoteles.bind(this);
    this.handleCheckboxHoteles = this.handleCheckboxHoteles.bind(this);
    this.handleInvertir = this.handleInvertir.bind(this);
    this.handleDesmarcarTodo = this.handleDesmarcarTodo.bind(this);
    this.handleFiltroCupos = this.handleFiltroCupos.bind(this);
    this.armarCupos = this.armarCupos.bind(this);
    this.onSliderChangeFecha = this.onSliderChangeFecha.bind(this);
    this.onSliderChangePrecio = this.onSliderChangePrecio.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.original !== prevProps.original) {
      this.prepararFiltros(this.props.original);
      this.setState({ paquetes: this.props.original }, () => this.aplicarFiltros());
    }
  }

  onSliderChangePrecio(precio) {
    this.setState({ precio });
  }

  onSliderChangeFecha(fechas) {
    this.setState({ fechas });
  }

  prepararFiltros(paquetes) {
    let hoteles = [];
    const cantNoches = [];
    const proveedores = [];
    const categoriaHotel = [];
    const contadores = {
      categoriaHotel: null,
      hoteles: null,
      proveedores: null,
      cantNoches: null,
    };
    let max = null;
    let min = null;
    let fechaMaxima = null;
    let fechaMinima = null;
    let cont = 0;

    // categoriaHotel
    for (let i = 1; i <= 5; i++) {
      if (i === 1) {
        categoriaHotel.push({ nombre: '1 Estrella', visible: false });
      } else {
        const nombre = `${i} Estrellas`;
        categoriaHotel.push({ nombre, visible: false });
      }
    }
    contadores.categoriaHotel = 5;
    //this.setState({ categoriaHotel });

    // proveedores
    cont = 0;
    paquetes.map((p) => {
      let encontrado = false;
      const nombre = p.operadorResponsable.nombre;
      const logoUrl = p.operadorResponsable.logourl;
      proveedores.map((prove) => {
        if (prove.nombre == nombre) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        proveedores.push({ nombre, logoUrl, visible: false });
        cont++;
        encontrado = false;
      }
    });
    contadores.proveedores = cont;
    //this.setState({ proveedores });

    // cantidad de noches
    cont = 0;
    paquetes.map((p) => {
      let encontrado = false;
      const noches = p.cantNoches;
      cantNoches.map((n) => {
        if (n.nombre == noches) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        cont++;
        cantNoches.push({ nombre: noches, visible: false });
        encontrado = false;
      }
    });
    contadores.cantNoches = cont;
    //this.setState({ cantNoches });

    // precios
    paquetes.map((p) =>
      p.salidas.map((s) => {
        const valor =
          (s.precios.precioNeto + s.precios.impuestos + s.precios.iva) /
          this.props.cantidadPasajeros;
        max = max < valor || max === null ? valor : max;
        min = min > valor || min === null ? valor : min;
      }),
    );

    //this.setState({ precioMaximo: Math.ceil(max / 100) * 100 });
    //this.setState({ precioMinimo: Math.floor(min / 100) * 100 });
    //this.setState({ precio: [Math.floor(min / 100) * 100, Math.ceil(max / 100) * 100] });
    //const precioMaximo = (Math.ceil(max / 100) * 100);
    //const precioMinimo = (Math.floor(min / 100) * 100);
    //const precio = (Math.floor(min / 100) * 100, Math.ceil(max / 100) * 100);
    // Hoteles
    cont = 0;
    paquetes.map((p) =>
      p.salidas.map((s) =>
        s.hoteles.map((h) => {
          if (h.nombre !== null) {
            if (hoteles.indexOf(h.nombre.split(' *')[0]) === -1) {
              hoteles.push(h.nombre.split(' *')[0]);
              cont++;
            }
          }
        }),
      ),
    );
    contadores.hoteles = cont;
    hoteles = hoteles.sort();
    hoteles = hoteles.map((h) => ({ nombre: h, visible: false }));
    //this.setState({ hoteles });

    // Fechas
    paquetes.map((p) =>
      p.salidas.map((s) => {
        fechaMaxima =
          fechaMaxima < s.fechaSalida || fechaMaxima === null ? s.fechaSalida : fechaMaxima;
        fechaMinima =
          fechaMinima > s.fechaSalida || fechaMinima === null ? s.fechaSalida : fechaMinima;
      }),
    );
    fechaMinima = Math.floor(new Date(fechaMinima).getTime() / 1000);
    fechaMaxima = Math.floor(new Date(fechaMaxima).getTime() / 1000);

    //this.setState({ fechaMinima });
    //this.setState({ fechaMaxima });
    const fechas = [fechaMinima, fechaMaxima];
    //this.setState({ fechas });

    this.setState({
      categoriaHotel,
      proveedores,
      cantNoches,
      precio: [Math.floor(min / 100) * 100, Math.ceil(max / 100) * 100],
      precioMinimo: Math.floor(min / 100) * 100,
      precioMaximo: Math.ceil(max / 100) * 100,
      hoteles,
      fechaMinima,
      fechaMaxima,
      fechas,
      contadores,
    });
  }

  aplicarFiltros() {
    let paquetes = Object.assign({}, this.props.original);

    if (this.contadorChecks(this.state.proveedores)) {
      paquetes = this.aplicarFiltroProveedor(paquetes);
    }

    if (this.contadorChecks(this.state.categoriaHotel)) {
      paquetes = this.aplicarFiltroCategoriaHotel(paquetes);
    }

    if (this.contadorChecks(this.state.hoteles)) {
      paquetes = this.aplicarFiltroHoteles(paquetes);
    }

    if (this.contadorChecks(this.state.cantNoches)) {
      paquetes = this.aplicarFiltroCantNoches(paquetes);
    }

    if (this.state.filtroCupos === true) {
      paquetes = this.aplicarFiltroCupos(paquetes);
    }

    paquetes = this.aplicarFiltroPrecios(paquetes);

    paquetes = this.aplicarFiltroFechas(paquetes);

    paquetes = this.aplicarFiltroInvertir(paquetes);

    if (paquetes !== this.props.original && paquetes !== this.state.paquetes) {
      this.setState({ paquetes }, () => this.props.setPaqueteFiltrados(paquetes));
    }
  }

  contadorChecks(lista) {
    let cont = 0;
    for (const index in lista) {
      const item = lista[index];
      if (item.visible) {
        cont++;
      }
    }
    return cont > 0 && cont < Commons.length(lista);
  }

  aplicarFiltroCantNoches(paquetes) {
    const { cantNoches } = this.state;
    const paqueteNuevo = [];
    for (let paquete in paquetes) {
      paquete = paquetes[paquete];
      for (let noches in cantNoches) {
        noches = cantNoches[noches];
        if (paquete.cantNoches == noches.nombre && noches.visible) {
          paqueteNuevo.push(paquete);
        }
      }
    }
    return paqueteNuevo;
  }

  aplicarFiltroFechas(paquetes) {
    const filtrados = [];
    const { fechas } = this.state;
    const min = new Date(fechas[0] * 1000);
    const max = new Date(fechas[1] * 1000);

    for (let i = 0; i < Commons.length(paquetes); i++) {
      const paquete = paquetes[i];
      const p = { ...paquete };
      p.salidas = [];
      for (let j = 0; j < Commons.length(paquete.salidas); j++) {
        const salida = paquete.salidas[j];
        let fechaSalida = paquete.salidas[j].fechaSalida;
        fechaSalida = new Date(fechaSalida);
        if (fechaSalida >= min && fechaSalida <= max) {
          p.salidas.push({ ...salida });
        }
      }
      if (Commons.length(p.salidas) !== 0) {
        filtrados.push(p);
      }
    }

    return filtrados;
  }

  aplicarFiltroPrecios(paquetes) {
    const filtrados = [];
    const min = this.state.precio[0];
    const max = this.state.precio[1];

    for (let i = 0; i < Commons.length(paquetes); i++) {
      const paquete = paquetes[i];
      const p = { ...paquete };
      p.salidas = [];
      for (let j = 0; j < Commons.length(paquete.salidas); j++) {
        const salida = paquete.salidas[j];
        const valor =
          (salida.precios.precioNeto + salida.precios.iva + salida.precios.impuestos) /
          this.props.cantidadPasajeros;
        if (valor >= min && valor <= max) {
          p.salidas.push({ ...salida });
        }
      }
      if (Commons.length(p.salidas) !== 0) {
        filtrados.push(p);
      }
    }
    return filtrados;
  }

  aplicarFiltroInvertir(paquetes) {
    if (this.state.invertirPrecio) {
      paquetes.map((p) => {
        p.salidas.sort((a, b) => {
          if (
            a.precios.precioNeto + a.precios.impuestos + a.precios.iva >
            b.precios.precioNeto + b.precios.impuestos + b.precios.iva
          ) {
            return -1;
          }
          if (
            a.precios.precioNeto + a.precios.impuestos + a.precios.iva <
            b.precios.precioNeto + b.precios.impuestos + b.precios.iva
          ) {
            return 1;
          }
          return 0;
        });
      });

      paquetes.sort((a, b) => {
        if (
          a.salidas[0].precios.precioNeto +
            a.salidas[0].precios.impuestos +
            a.salidas[0].precios.iva >
          b.salidas[0].precios.precioNeto +
            b.salidas[0].precios.impuestos +
            b.salidas[0].precios.iva
        ) {
          return -1;
        }
        if (
          a.salidas[0].precios.precioNeto +
            a.salidas[0].precios.impuestos +
            a.salidas[0].precios.iva <
          b.salidas[0].precios.precioNeto +
            b.salidas[0].precios.impuestos +
            b.salidas[0].precios.iva
        ) {
          return 1;
        }
        return 0;
      });
    } else {
      paquetes.map((p) => {
        p.salidas.sort((a, b) => {
          if (
            a.precios.precioNeto + a.precios.impuestos + a.precios.iva >
            b.precios.precioNeto + b.precios.impuestos + b.precios.iva
          ) {
            return 1;
          }
          if (
            a.precios.precioNeto + a.precios.impuestos + a.precios.iva <
            b.precios.precioNeto + b.precios.impuestos + b.precios.iva
          ) {
            return -1;
          }
          return 0;
        });
      });

      paquetes.sort((a, b) => {
        if (
          a.salidas[0].precios.precioNeto +
            a.salidas[0].precios.impuestos +
            a.salidas[0].precios.iva >
          b.salidas[0].precios.precioNeto +
            b.salidas[0].precios.impuestos +
            b.salidas[0].precios.iva
        ) {
          return 1;
        }
        if (
          a.salidas[0].precios.precioNeto +
            a.salidas[0].precios.impuestos +
            a.salidas[0].precios.iva <
          b.salidas[0].precios.precioNeto +
            b.salidas[0].precios.impuestos +
            b.salidas[0].precios.iva
        ) {
          return -1;
        }
        return 0;
      });
    }

    return paquetes;
  }

  aplicarFiltroProveedor(paquetes) {
    const proveedores = this.state.proveedores;
    const paqueteNuevo = [];
    for (let paquete in paquetes) {
      paquete = paquetes[paquete];
      for (let prov in proveedores) {
        prov = proveedores[prov];
        if (paquete.operadorResponsable.nombre == prov.nombre && prov.visible) {
          paqueteNuevo.push(paquete);
        }
      }
    }
    return paqueteNuevo;
  }

  aplicarFiltroCategoriaHotel(paquetes) {
    const categoriaHotel = this.state.categoriaHotel;
    const paqueteNuevo = [];
    for (let p in paquetes) {
      p = paquetes[p];
      let estado = false;
      p.salidas.map((s) => {
        s.hoteles.map((h) => {
          for (let item in categoriaHotel) {
            item = categoriaHotel[item];
            const clase = item.nombre.split(' ')[0];
            if (item.visible && h.clase == clase) {
              estado = true;
            }
          }
        });
      });
      if (estado) {
        paqueteNuevo.push(p);
      }
    }
    return paqueteNuevo;
  }

  aplicarFiltroHoteles(paquetes) {
    const hoteles = this.state.hoteles;
    const paqueteNuevo = [];
    for (let p in paquetes) {
      p = paquetes[p];
      let estado = false;
      p.salidas.map((s) => {
        s.hoteles.map((h) => {
          for (const hotel in hoteles) {
            const nombres = hoteles[hotel].nombre.split(' *')[0];
            const visible = hoteles[hotel].visible;
            if (h.nombre === nombres && visible) {
              estado = true;
            }
          }
        });
      });
      if (estado) {
        paqueteNuevo.push(p);
      }
    }
    return paqueteNuevo;
  }

  armarCantNoches(cantNoches) {
    const lista = [];

    for (let item in cantNoches) {
      item = cantNoches[item];
      const clase = item.visible == true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id="cantNoches" className={clase} onClick={this.handleCheckbox}>
          <input
            id="cantNoches"
            style={{ display: 'none' }}
            name={item.nombre}
            type="checkbox"
            checked={item.visible}
            onChange={this.handleCheckbox}
          />
          {item.nombre} nts
          <br />
        </div>,
      );
    }
    return lista.map((c) => c);
  }

  armarOperadores(proveedores) {
    const lista = [];
    for (let item in proveedores) {
      item = proveedores[item];
      const clase = item.visible == true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id="proveedores" className={clase} onClick={this.handleCheckbox}>
          <input
            id="proveedores"
            style={{ display: 'none' }}
            name={item.nombre}
            type="checkbox"
            checked={item.visible}
            onChange={this.handleCheckbox}
          />
          {item.nombre}
          <br />
        </div>,
      );
    }
    return lista.map((c) => c);
  }

  armarCategoriaHotel() {
    const categoriaHotel = this.state.categoriaHotel;
    const lista = [];
    for (let item in categoriaHotel) {
      item = categoriaHotel[item];
      const clase = item.visible == true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id="categoriaHotel" className={clase} onClick={this.handleCheckbox}>
          <label>
            <input
              readOnly
              id="categoriaHotel"
              style={{ display: 'none' }}
              name={item.nombre}
              type="checkbox"
              checked={item.visible}
              onClick={this.handleCheckbox}
            />
            <CategoriaEstrella
              clase={item.nombre.split(' ')[0]}
              color={item.visible}
              name={item.nombre}
            />
          </label>
          <br />
        </div>,
      );
    }
    return lista.map((c) => c);
  }

  armarHoteles(hoteles) {
    const lista = [];
    for (let item in hoteles) {
      item = hoteles[item];
      const clase = item.visible == true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id="hoteles" className={clase} onClick={this.handleCheckboxHoteles}>
          <input
            readOnly
            id="hoteles"
            name={item.nombre}
            style={{ display: 'none' }}
            type="checkbox"
            checked={item.visible}
            onClick={this.handleCheckboxHoteles}
          />
          {item.nombre}
          <br />
        </div>,
      );
    }
    return lista.map((c) => c);
  }

  handleCheckboxHoteles(event) {
    event.preventDefault();
    const target = event.target.querySelector('input');
    const name = target.name;
    const state = { ...this.state[target.id] };

    for (let item in state) {
      item = state[item];
      if (item.nombre == name) {
        item.visible = !item.visible;
      }
    }

    this.setState({ [target.id]: state }, () => this.aplicarFiltros());
  }

  handleInvertir(e) {
    const invertirPrecio = !this.state.invertirPrecio;
    this.setState({ invertirPrecio }, () => this.aplicarFiltros());
  }

  handleCheckbox(event) {
    event.preventDefault();
    let target = event.target.querySelector('input');
    if (target == null) {
      target = event.target;
    }
    const state = { ...this.state[target.id] };
    let name = target.name;
    if (name == null) {
      name = target.title;
    }

    for (let item in state) {
      item = state[item];
      if (item.nombre == name) {
        item.visible ? (item.visible = false) : (item.visible = true);
      }
    }
    this.setState({ [target.id]: state }, () => this.aplicarFiltros());
  }

  handleDesmarcarTodo(e) {
    e.preventDefault();
    const state = { ...this.state[e.target.id] };
    for (let item in state) {
      item = state[item];
      item.visible = false;
    }
    this.setState({ [e.target.id]: state }, () => this.aplicarFiltros());
  }

  logueoCupos(paquetes) {
    paquetes.map((paquete) => {
      paquete.salidas.map((salida) => {
      });
    });
  }

  disableCheck() {
    const sinCupo = document.getElementById('sinCupo');
    const conCupo = document.getElementById('tieneCupo');

    conCupo.checked
      ? (sinCupo.setAttribute('disabled', 'disabled'), sinCupo.setAttribute('value', 'false'))
      : (sinCupo.removeAttribute('disabled'), sinCupo.setAttribute('value', 'true'));
    sinCupo.checked
      ? (conCupo.setAttribute('disabled', 'disabled'), conCupo.setAttribute('value', 'false'))
      : (conCupo.removeAttribute('disabled'), conCupo.setAttribute('value', 'true'));

    console.log(conCupo);
    console.log(sinCupo);
  }

  handleFiltroCupos() {
    const { filtroCupos } = this.state;
    this.setState({ filtroCupos: !filtroCupos }, () => this.aplicarFiltros());
  }

  aplicarFiltroCupos(paquetes) {
    this.setState({
      cargando: true,
    });

    const filtrados = [];

    for (let i = 0; i < Commons.length(paquetes); i++) {
      const paquete = paquetes[i];
      const p = { ...paquete };
      p.salidas = [];
      for (let j = 0; j < Commons.length(paquete.salidas); j++) {
        const salida = paquete.salidas[j];

        if (salida.cupos > 0) {
          p.salidas.push({ ...salida });
        }
      }
      if (Commons.length(p.salidas) !== 0) {
        filtrados.push(p);
      }
    }

    this.setState({
      cargando: false,
    });
    return filtrados;

    // for( var paquete in paquetes){
    //     paquete = paquetes[paquete];
    // }

    // const {disponible} = this.state;

    // for( var paquete in paquetes ){
    //     paquete = paquetes[paquete];
    //     for(var disponibles in disponible){
    //         disponibles = disponible[disponibles];
    //         if(paquete.disponible == disponibles.nombre && disponibles.visible){
    //             paqueteNuevo.push(paquete);
    //         }
    //     }
    // }
    // return paqueteNuevo;
  }

  armarCupos(disponible) {
    const lista = [];
    for (let item in disponible) {
      item = disponible[item];

      lista.push(
        <div key={item} id="cantCupos">
          <input
            id="cantCupos"
            style={{ display: 'none' }}
            name={item.nombre}
            type="checkbox"
            checked={item.visible}
          />
          {item.nombre}
          <br />
        </div>,
      );
    }
    return lista.map((c) => c);
  }

  render() {
    const { t } = this.props;
    const { precio, precioMinimo, precioMaximo, fechaMinima, fechaMaxima, fechas, filtroCupos } =
      this.state;
    const { mostrarOperador, show } = this.props;

    // this.logueoCupos(this.state.paquetes)

    if (this.props.original !== [] && this.props.original && show) {
      return (
        <div>
          <div className="panel panel-default custom">
            <div className="panel-body p-4 mb-2" style={{ background: '#eee' }}>
              <label>{t('filters.price')}</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className="btn">
                <i id="precio" className="fa fa-sort fa-2x" onClick={this.handleInvertir} />
                <br />
              </div>
              <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                <Range
                  allowCross={false}
                  value={precio}
                  min={precioMinimo}
                  max={precioMaximo}
                  onChange={this.onSliderChangePrecio}
                  onAfterChange={this.aplicarFiltros}
                  trackStyle={[{ backgroundColor: '#000000' }, { backgroundColor: '#000000' }]}
                  handleStyle={[{ backgroundColor: '#000000' }, { backgroundColor: '#000000' }]}
                />
                <br />
              </div>
              <div className="h-8">
                <input
                  style={{
                    width: '31%',
                    margin: '0px',
                    padding: '6px',
                    float: 'left',
                    display: 'inline-block',
                    background: '#ffffff',
                  }}
                  className="form-control"
                  value={`${precio[0]}`}
                  readOnly
                />
                <input
                  style={{
                    width: '31%',
                    margin: '0px',
                    padding: '6px',
                    float: 'right',
                    display: 'inline-block',
                    background: '#ffffff',
                  }}
                  className="form-control"
                  value={`${precio[1]}`}
                  readOnly
                />
              </div>
            </div>
          </div>
          <div className="panel panel-default custom">
            <div className="panel-body p-4 mb-2" style={{ background: '#eee' }}>
              <label className="text-left">{t('filters.departureDate')}</label>
              <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                <Range
                  allowCross={false}
                  value={fechas}
                  min={fechaMinima}
                  max={fechaMaxima}
                  onChange={this.onSliderChangeFecha}
                  onAfterChange={this.aplicarFiltros}
                  trackStyle={[{ backgroundColor: '#000000' }, { backgroundColor: '#000000' }]}
                  handleStyle={[{ backgroundColor: '#000000' }, { backgroundColor: '#000000' }]}
                />
                <br />
              </div>
              <div className="h-8">
                <input
                  style={{
                    width: '31%',
                    margin: '0px',
                    padding: '4px',
                    float: 'left',
                    display: 'inline-block',
                    background: '#ffffff',
                  }}
                  className="form-control"
                  value={moment.unix(fechas[0]).format('DD/MM/YYYY')}
                  readOnly
                />
                <input
                  style={{
                    width: '31%',
                    margin: '0px',
                    padding: '4px',
                    float: 'right',
                    display: 'inline-block',
                    background: '#ffffff',
                  }}
                  className="form-control"
                  value={moment.unix(fechas[1]).format('DD/MM/YYYY')}
                  readOnly
                />
              </div>
            </div>
          </div>
          {mostrarOperador ? (
            <div className="panel panel-default custom">
              <div className="panel-body p-4 mb-2" style={{ background: '#eee' }}>
                <label>{t('filters.supplier')}</label>
                <div style={{ float: 'right', margin: '0px', padding: '0px' }} className="">
                  <label
                    id="proveedores"
                    className="desmarcarTodo"
                    onClick={this.handleDesmarcarTodo}
                  >
                    {t('filters.uncheck')}
                  </label>
                  <br />
                </div>
                <br />
                {Commons.length(this.state.proveedores) !== 0
                  ? this.armarOperadores(this.state.proveedores)
                  : null}
              </div>
            </div>
          ) : null}

          <div className="panel panel-default custom">
            <div className="panel-body p-4 mb-2" style={{ background: '#eee' }}>
              <label>{t('filters.availability')}</label>
              <div className="form-check form-check-inline">
                <input
                  checked={filtroCupos}
                  style={{ padding: '5px' }}
                  className="form-check-input"
                  type="checkbox"
                  id="filtroCupos"
                  value="true"
                  onChange={this.handleFiltroCupos}
                  disabled={this.state.cargando}
                  value="Enable"
                />
                <label style={{ padding: '5px' }} className="form-check-label">
                  {t('filters.availableNow')}
                </label>
              </div>
              {/*

                        <div className="form-check form-check-inline">
                            <input style={{padding:"5px"}} onClick={this.disableCheck} className="form-check-input" type="checkbox" id="sinCupo" value="true" onMouseOver={this.} />
                            <label style={{padding:"5px"}} className="form-check-label" for="inlineCheckbox2">Sin Cupos</label>

                        </div>

                        {
                            Commons.length(this.state.disponible) !== false ?
                                this.armarCantNoches(this.state.disponible) : null
                        } */}
            </div>
          </div>

          <div className="panel panel-default custom">
            <div className="panel-body p-4 mb-2" style={{ background: '#eee' }}>
              <label>{t('filters.nightsQuantity')}</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className="">
                <label id="cantNoches" className="desmarcarTodo" onClick={this.handleDesmarcarTodo}>
                  {t('filters.uncheck')}
                </label>
                <br />
              </div>
              <br />
              {Commons.length(this.state.cantNoches) !== 0
                ? this.armarCantNoches(this.state.cantNoches)
                : null}
            </div>
          </div>
          <div className="panel panel-default custom">
            <div className="panel-body p-4 mb-2" style={{ background: '#eee' }}>
              <label>{t('filters.categoryHotel')}</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className="">
                <label
                  id="categoriaHotel"
                  className="desmarcarTodo"
                  onClick={this.handleDesmarcarTodo}
                >
                  {t('filters.uncheck')}
                </label>
                <br />
              </div>
              <br />
              {Commons.length(this.state.categoriaHotel) !== 0 ? this.armarCategoriaHotel() : null}
            </div>
          </div>
          <div className="panel panel-default custom">
            <div className="panel-body p-4 mb-2" style={{ background: '#eee' }}>
              <label>{t('filters.hotels')}</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className="">
                <label id="hoteles" className="desmarcarTodo" onClick={this.handleDesmarcarTodo}>
                  {t('filters.uncheck')}
                </label>
                <br />
              </div>
              <br />
              {this.state.hoteles !== null ? this.armarHoteles(this.state.hoteles) : null}
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}
//
// Filtros.propTypes = {
//     paquetes: PropTypes.array,
// };

const mapStateToProps = (state) => state.packages;
const mapDispatchToProps = (dispatch) => bindActionCreators({ setPaqueteFiltrados }, dispatch);
/* eslint-enable */
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(['translations'])(Filtros));
